import { render, staticRenderFns } from "./DiscountChargeItem.vue?vue&type=template&id=9cf4ebac&scoped=true&"
import script from "./DiscountChargeItem.vue?vue&type=script&lang=js&"
export * from "./DiscountChargeItem.vue?vue&type=script&lang=js&"
import style0 from "./DiscountChargeItem.vue?vue&type=style&index=0&id=9cf4ebac&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf4ebac",
  null
  
)

export default component.exports